import { Radio } from "antd";
import { adminApis } from "api";
import { colors } from "constants/colors";
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";

const questions = [
  "Та олсон үнийн дүнгээсээ илүү их зарлага гаргасан уу?",
  "Та ижил сэтгэл хөдлөл мэдрэхийн тулд их хэмжээний мөнгөөр мөрийтэй тоглож байсан уу?",
  "Та мөрийтэй тоглох үед алдсан мөнгөө буцааж хожихын тулд өөр нэг (тухайн өдөр) дахин оролцож байсан уу?",
  "Та дахин тоглохын тулд хүнээс зээлэх эсвэл өөрт байгаа эд зүйлээ зарж байсан уу?",
  "Та өөрийгөө мөрийтэй тоглоомтой холбоотой асуудалтай болсон байна гэж бодож байсан уу?",
  "Та жилийн хугацаанд мөрийтэй тоглоомоос болж стресс, түгшүүрийн мэдрэмж авч байсан уу?",
  "Таныг хэн нэгэн мөрийтэй тоглоомд донтсон эсвэл энэ талаар шүүмжилж байсан уу?",
  "Таныг мөрийтэй тоглох үед танд болон танай гэр бүлийн санхүүгийн хүндрэл учруулсан уу?",
  "Мөрийтэй тоглож байх үедээ гэм буруутай мэдрэмж төрүүлж байсан уу?",
];

const answerOptions = [
  { label: "Үгүй", score: 0 },
  { label: "Заримдаа", score: 1 },
  { label: "Ихэнх үедээ", score: 2 },
  { label: "Байнга", score: 3 },
];

const firstQuestionSubtitle =
  "Та энэхүү тестэнд оролцохдоо сүүлийн 12 сарын байдлаар бодож бөглөнө үү.";

const resultDisclaimer =
  "Эдгээр дүгнэлт нь эмчийн лавлагаа биш бөгөөд судалгаан дээр үндэслэсэн дүгнэлт юм. Та сэтгэл зүйн талаар мэдээлэл, зөвлөгөө авахыг хүсвэл 70150520-1 холбогдоно уу.";

function getResultMessage(total) {
  if (total <= 2) {
    return {
      level: "Бага эрсдэлтэй",
      color: "#22c55e",
      message:
        "0-2 оноо авсан бол та бага эрсдэлтэй тоглогч, та өөрийн санхүүгийн байдлыг хянаж хариуцлагатай оролцдог хэрэглэгч байна. Гэхдээ та эрсдэлээ үүнээс дээш нэмбэл өөртөө хяналт тавих шаардлагатай болно.",
    };
  }
  if (total <= 7) {
    return {
      level: "Дунд зэргийн эрсдэлтэй",
      color: "#eab308",
      message:
        "3-7 оноо авсан бол та дунд зэргийн эрсдэлтэй тоглогч буюу зарим үед санхүүгийн эрсдэл өөртөө үүсгэдэг, сэтгэл зүйчтэй ярилцахыг зөвлөж байна.",
    };
  }
  return {
    level: "Өндөр эрсдэлтэй",
    color: "#ef4444",
    message:
      "8 ба түүнээс дээш оноо авсан бол хяналтаа алдах магадлал өндөр бөгөөд тусламж авах эмнэлэг, сэтгэл зүйн төвийн тусламж авахыг зөвлөж байна. Энэ нь та ганцаараа биш бөгөөд энэ шийдэж болох асуудал хүндээр хүлээж авахгүй байхыг хүсье.",
  };
}

export default function ResponsibleGaming() {
  const [current, setCurrent] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [finished, setFinished] = useState(false);
  const isScoreSavedRef = useRef(false);

  const handleSelect = (score) => {
    setSelected(score);
  };

  const handleNext = () => {
    if (selected === null) return;
    const newAnswers = answers.slice(0, current);
    newAnswers.push(selected);
    if (current + 1 < questions.length) {
      setAnswers(newAnswers);
      setCurrent(current + 1);
      setSelected(null);
    } else {
      setAnswers(newAnswers);
      setFinished(true);
    }
  };

  const handleBack = () => {
    if (current > 0) {
      const prev = current - 1;
      const prevAnswers = answers.slice(0, current);
      setAnswers(prevAnswers.slice(0, prev));
      setCurrent(prev);
      setSelected(prevAnswers[prev] !== undefined ? prevAnswers[prev] : null);
    }
  };

  const currentSelected = selected;

  const handleRestart = () => {
    setCurrent(0);
    setAnswers([]);
    setSelected(null);
    setFinished(false);
    isScoreSavedRef.current = false;
  };

  const totalScore = answers.reduce((sum, s) => sum + s, 0);
  const result = finished ? getResultMessage(totalScore) : null;

  useEffect(() => {
    if (
      !finished ||
      answers.length !== questions.length ||
      isScoreSavedRef.current
    ) {
      return;
    }

    isScoreSavedRef.current = true;
    adminApis.savePoint(totalScore).catch(() => {
      isScoreSavedRef.current = false;
    });
  }, [finished, answers.length, totalScore]);

  return (
    <div className="bg-black10 min-h-screen">
      <Helmet>
        <title>Megaball | Хариуцлагатай тоглолт</title>
      </Helmet>

      {/* Header Banner */}
      <div
        className="flex mt-[93px] justify-center relative z-0 overflow-hidden h-[100px] items-center"
        style={{ backgroundColor: colors.primary }}
      >
        <p className="font-bold text-4xl text-white text-center md:text-[32px]">
          Хариуцлагатай тоглолт
        </p>
      </div>

      <div className="flex justify-center px-4 py-8">
        <div className="w-full" style={{ maxWidth: 680 }}>
          {!finished ? (
            <>
              {current === 0 && (
                <div className="mb-4 text-center px-1">
                  <p
                    className="text-base font-bold leading-relaxed"
                    style={{ color: "#0E308E" }}
                  >
                    {firstQuestionSubtitle}
                    <br />
                    {resultDisclaimer}
                  </p>
                </div>
              )}

              <div className="bg-white rounded-xl shadow-md p-6 md:p-4">
                {/* Progress */}
                <div className="mb-4">
                  <div className="flex justify-between items-center mb-1">
                    <span
                      className="text-xs font-medium"
                      style={{ color: colors.black55 }}
                    >
                      Асуулт {current + 1} / {questions.length}
                    </span>
                    <span
                      className="text-xs font-medium"
                      style={{ color: colors.primary }}
                    >
                      {Math.round((current / questions.length) * 100)}%
                    </span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-1.5">
                    <div
                      className="h-1.5 rounded-full transition-all duration-300"
                      style={{
                        width: `${(current / questions.length) * 100}%`,
                        backgroundColor: colors.primary,
                      }}
                    />
                  </div>
                </div>

                {/* Question */}
                <p
                  className="text-lg font-bold mb-5 leading-snug text-center md:text-xl"
                  style={{ color: "#0E308E" }}
                >
                  {current + 1}. {questions[current]}
                </p>

                {/* Answer Radio Options */}
                <div className="mb-5 flex justify-center">
                  <Radio.Group
                    value={currentSelected}
                    onChange={(e) => handleSelect(e.target.value)}
                    className="flex flex-wrap justify-center gap-x-6 gap-y-3"
                    style={{ color: "#0E308E" }}
                  >
                    {answerOptions.map((option) => (
                      <Radio
                        key={option.score}
                        value={option.score}
                        style={{ color: "#0E308E", fontWeight: 400 }}
                      >
                        {option.label}
                      </Radio>
                    ))}
                  </Radio.Group>
                </div>

                {/* Navigation Buttons */}
                <div className="flex justify-between items-center">
                  <button
                    onClick={handleBack}
                    disabled={current === 0}
                    className="px-4 py-2 rounded-lg border-2 font-semibold text-sm transition-opacity disabled:opacity-30"
                    style={{
                      borderColor: colors.primary,
                      color: colors.primary,
                      backgroundColor: "transparent",
                    }}
                  >
                    ← Өмнөх
                  </button>
                  <button
                    onClick={handleNext}
                    disabled={currentSelected === null}
                    className="px-4 py-2 rounded-lg font-semibold text-sm text-white transition-opacity disabled:opacity-30"
                    style={{ backgroundColor: colors.primary }}
                  >
                    {current + 1 === questions.length ? "Дуусгах" : "Дараах →"}
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div className="bg-white rounded-2xl shadow-md p-8 md:p-6 text-center">
              <p
                className="text-lg font-medium mb-2"
                style={{ color: colors.black55 }}
              >
                Нийт оноо
              </p>
              <p
                className="text-6xl font-bold mb-2 md:text-5xl"
                style={{ color: result.color }}
              >
                {totalScore}
              </p>
              <p className="text-sm mb-6" style={{ color: colors.black40 }}>
                / {questions.length * 3} оноо
              </p>

              <p
                className="text-sm leading-relaxed mb-6 px-4 py-3 rounded-lg"
                style={{ color: colors.black55, backgroundColor: "#F8FAFC" }}
              >
                {resultDisclaimer}
              </p>

              <div
                className="inline-block px-6 py-2 rounded-full font-bold text-white text-lg mb-6"
                style={{ backgroundColor: result.color }}
              >
                {result.level}
              </div>

              <p
                className="text-base leading-relaxed mb-8 md:text-sm"
                style={{ color: colors.black70 }}
              >
                {result.message}
              </p>

              {/* Score Breakdown */}
              <div className="text-left border rounded-xl overflow-hidden mb-8">
                <div
                  className="px-4 py-3 font-semibold text-white text-sm"
                  style={{ backgroundColor: colors.primary }}
                >
                  Хариултын дэлгэрэнгүй
                </div>
                {questions.map((q, i) => {
                  const answerOption = answerOptions.find(
                    (o) => o.score === answers[i],
                  );
                  return (
                    <div
                      key={i}
                      className="flex justify-between items-start gap-4 px-4 py-3 border-t text-sm"
                      style={{ color: colors.black70 }}
                    >
                      <span className="flex-1">
                        {i + 1}. {q}
                      </span>
                      <span
                        className="font-semibold whitespace-nowrap"
                        style={{ color: colors.primary }}
                      >
                        {answerOption?.label}
                      </span>
                    </div>
                  );
                })}
              </div>

              <button
                onClick={handleRestart}
                className="px-8 py-3 rounded-xl font-bold text-white text-lg transition-opacity hover:opacity-80"
                style={{ backgroundColor: colors.primary }}
              >
                Дахин тест өгөх
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
